import stepsimg from  "../../../Assets/Images/Insurance/steps-img.jpg"
export default function InsuranceSteps() {
  return (
    <section id="how-it-works" className="lg:tw-py-20 tw-py-10 tw-bg-white">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            3 Simple Steps to Protect Your Family
          </h2>
        </div>

        <div className="tw-grid md:tw-grid-cols-2 tw-gap-10 tw-items-center">
          <div>
            <div className="">
              <img src={stepsimg} alt=""className="tw-rounded tw-shadow-2xl tw-max-w-full tw-h-auto" />
            </div>
          </div>

          <div>
            <div className="tw-grid tw-gap-10">
              <div className="tw-text-start">
                <div className="tw-w-10 tw-h-10 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
                  <span className="tw-text-white tw-text-xl tw-font-bold">1</span>
                </div>
                <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue tw-mb-2">
                  Fill Your Details
                </h3>
              </div>

              <div className="tw-text-start">
                <div className="tw-w-10 tw-h-10 tw-bg-fintoo-orange tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
                  <span className="tw-text-white tw-text-2xl tw-font-bold">2</span>
                </div>
                <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue tw-mb-2">
                  Compare best-fit options
                </h3>
              </div>

              <div className="tw-text-start">
                <div className="tw-w-10 tw-h-10 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
                  <span className="tw-text-white tw-text-2xl tw-font-bold">3</span>
                </div>
                <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue tw-mb-2">
                  Decide with expert guidance
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
